import baseApi from "./baseApi"

export default  {
    async getAttributes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/attributes");
        return result.data;
    },
    async addAttribute(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/attributes", item);
        return result.data;
    },
    async updateAttribute(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/attributes", item);
        return result.data;
    }
}